import { SimpleSelect } from '@/components/ui/select-with-more'
import { cn } from '@/lib/utils'
import { EARLIEST_PLAUSIBLE_MODEL_YEAR, latestPlausibleModelYear } from '../models/equipment'

export const YearSelect = ({
  error,
  value,
  onChange,
  className,
}: {
  error: boolean
  /** Undefined when no year is set, so the placeholder shows. */
  value: string | undefined
  onChange: (value: string) => void
  className?: string
}) => {
  // Bounded by what a carrier will take, so the dropdown can't offer a year the confirm step blocks.
  const latest = latestPlausibleModelYear()
  const years = Array.from({ length: latest - EARLIEST_PLAUSIBLE_MODEL_YEAR + 1 }, (_, index) =>
    String(latest - index)
  )

  return (
    <SimpleSelect
      options={years.map((year) => ({ value: year, label: year }))}
      value={value}
      onValueChange={onChange}
      error={error}
      placeholder={years[0]}
      className={cn('w-full max-w-48', className)}
    />
  )
}
